import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ImportProceduresResponse } from "@/types";

async function importProcedures(
  request: FormData
): Promise<ImportProceduresResponse> {
  const response = await httpRequest.post<ImportProceduresResponse>(
    "/procedures/import",
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useImportProceduresMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importProcedures,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["procedures"] });
    },
  });
}